module.exports = __webpack_public_path__ + "static/media/lomardia_pernuy.efcb41a2.jpg";